export default __webpack_public_path__ + "static/media/couple.43485880.jpg";